import React from 'react'
import { RoleNames } from 'src/shared/hooks/useAuth'
import { useCurrentRol } from 'src/shared/widgets/hooks/general'
import SkeletonCards from '../SkeletonCard/SkeletonCard'
import CardsGastosList from '../CardGastosList/CardGastosList'
import { useGetGastosCategorasPorMesCardsQuery, useTotalesGastosSubcategoriaPorCategoriaCardsQuery } from 'src/gql/schema'
import { useProfile } from 'src/shared/hooks/useProfile'
import CardsGastosListFiltered from '../CardGastosListFiltered/CardGastosListFiltered'

const useGastosCards = ({ date = "", year = "", categoryId = "", categoryName = "", disableDetails = false }) => {
    const mode = useCurrentRol()
    const { hotel_id } = useProfile()
    const { data: gastosDelMes, refetch: refetchGastosCategorias, loading } = useGetGastosCategorasPorMesCardsQuery({
        variables: {
            gastosCategoria: (parseInt(date) + 1).toString(),
            mes_y_anio: `${(parseInt(date) + 1)}-${year}`,
            hotel_id,
        },
        skip: !!categoryId
    })

    const { data: gastosByCategory, refetch: refetchGastosByCategoria, loading: filteredGastosLoading } = useTotalesGastosSubcategoriaPorCategoriaCardsQuery({
        variables: {
            // Obtener todas las categorías de gastos
            cantidad_categorias: 5,
            categoria_id: categoryId,
            hotel_id,
            mes_y_anio: `${(parseInt(date) + 1)}-${year}`
        },
        skip: !categoryId
    })

    return {
        refetchGastosCategorias: () => {
            if ([RoleNames.admin, RoleNames.gerente, RoleNames.superadmin].includes(mode)) {
                if (categoryId) {
                    return refetchGastosByCategoria({
                        cantidad_categorias: 4,
                        categoria_id: categoryId,
                        hotel_id,
                        mes_y_anio: `${(parseInt(date) + 1)}-${year}`
                    })
                }
                refetchGastosCategorias({
                    hotel_id,
                    gastosCategoria: (parseInt(date) + 1).toString(),
                })
            }
        },
        Cards: (
            <div>
                {
                    [RoleNames.admin, RoleNames.superadmin, RoleNames.gerente].includes(mode) && !categoryId.length &&
                    <div className="gastos-cards">
                        {loading ?
                            <SkeletonCards /> :
                            <CardsGastosList disableDetails={disableDetails} gastosDelMes={gastosDelMes} month={parseInt(date)} />
                        }
                    </div>
                }
                {
                    [RoleNames.admin, RoleNames.superadmin, RoleNames.gerente].includes(mode) && !!categoryId.length &&
                    <div className="gastos-cards">
                        {filteredGastosLoading ?
                            <SkeletonCards /> :
                            <CardsGastosListFiltered
                                title={categoryName}
                                total={gastosByCategory?.totales_gastos_subcategoria_por_categoria.total_gasto}
                                gastosDelMes={gastosByCategory?.totales_gastos_subcategoria_por_categoria.subcategorias?.map((subcat) => ({
                                    number: subcat.monto,
                                    percent: subcat.porcentaje ? subcat.porcentaje + "" : "",
                                    title: subcat.subcategoria
                                })) || []}
                                month={parseInt(date)}
                            />
                        }
                    </div>
                }
            </div>
        )
    }
}

export default useGastosCards